import { getFileName, getFileNameWithExtension } from "../../utils/file/filePath";
import { BucketObjectItem } from "./BucketObjectItem";
import { BucketObjectType } from "./types/BucketObjectType";

export type BucketObject = BucketFolder | BucketFile;

export interface BucketFolder extends BucketObjectBase {
    type: BucketObjectType.Folder;
}

export interface BucketFile extends BucketObjectBase {
    type: BucketObjectType.File;
    sizeInBytes: number;
    lastModified: string;
    isInactive?: boolean;
}

interface BucketObjectBase {
    id: string;
    type: BucketObjectType;
    path: string;
    parentPath: string;
    name: string;
    isSelectable?: boolean | string;
}

export const isObjectFolder = (object: BucketObject): object is BucketFolder => object.type === BucketObjectType.Folder;
export const isObjectFile = (object: BucketObject): object is BucketFile => object.type === BucketObjectType.File;

export const mapItemToBucketObject = (object: BucketObjectItem): BucketObject => {
    switch (object.type) {
        case BucketObjectType.File: {
            return {
                id: getFileNameWithExtension(object.path),
                type: BucketObjectType.File,
                path: object.path,
                parentPath: object.parentPath,
                name: getFileNameWithExtension(object.path),
                sizeInBytes: object.sizeInBytes,
                lastModified: object.lastModified,
                isSelectable: object.isSelectable,
                isInactive: object.isInactive
            };
        }

        case BucketObjectType.Folder: {
            return {
                id: getFileNameWithExtension(object.path),
                type: BucketObjectType.Folder,
                path: object.path,
                parentPath: object.parentPath,
                name: object.name,
                isSelectable: object.isSelectable
            };
        }
    }
};
